// importing local assets:
import {
  spendWise,
  boomEscape,
  uarQueue,
  altrbot,
  hiddenReads,
  flockingSimulation
} from "../../../assets/projects/export";

export const ProjectsData = [
  {
    title: "Altrbot - Altersense",
    description:
      "Altrbot is an AlterSense RPA product and the largest SaaS Django backend project I have worked on so far. Worked mainly on the back-end while maintaining the legacy front-end and deployment pipeline with Docker for multiple client instances.",
    imgLink: [...altrbot],
    visitLink: "https://www.altersense.com/",
    codeLink: "",
  },
  {
    title: "UAR Queue System",
    description:
      "A client project for managing a stream queue. User's submitted their songs and joined the queue for review in the stream. The source repository is private. This one of my first real world projects. The project uses React, FastAPI, and MongoDB.",
    imgLink: [...uarQueue],
    visitLink: "",
    codeLink: "",
  },
  {
    title: "SpendWise",
    description:
      "SpendWise is a financial tracking web app built with Firebase and React. It taught me the challenges of teamwork, Git, GitHub, and organizing a shared codebase.",
    imgLink: [...spendWise],
    visitLink: "https://spendwise.naimur29.site/",
    codeLink: "https://github.com/naimur-29/SpendWise",
  },
  {
    title: "Hidden Reads",
    description:
      "A React, TypeScript, and Firebase project for reading and managing light novels and web novels. I explored CSS animations and URL systems that preserve application state.",
    imgLink: [...hiddenReads],
    visitLink: "https://hiddenreads.naimur29.site/",
    codeLink: "https://github.com/naimur-29/Hidden-Reads",
  },
  {
    title: "BoomEscape",
    description:
      "BoomEscape is a web-based game, similar to Minesweeper. This was a fun game project using pure JavaScript.",
    imgLink: [...boomEscape],
    visitLink: "https://boomescape.naimur29.site/",
    codeLink: "https://github.com/naimur-29/BoomEscape",
  },
    {
    title: "Flocking Simulation",
    description:
      "A flocking simulation built with p5.js to learn the flocking algorithm. I also implemented a quadtree to improve the simulation's spatial searches.",
    imgLink: [...flockingSimulation],
    visitLink: "https://flocking.naimur29.site/",
    codeLink: "",
  },
];
